import { Select, Row, Col } from "antd";
import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import "./style.css";

const { Option } = Select;

const getDropDownOptions = () => {
  const selectOptions = [
    {
      key: 1,
      text: "Last 1 min",
    },
    {
      key: 5,
      text: "Last 5 mins",
    },
    {
      key: 10,
      text: "Last 10 mins",
    },
  ];
  return selectOptions;
};

const RealTimeRange = ({ timeRange, showText = true, onTimeFilterChange }) => {
  const [dropDownOptions, setDropDownOptions] = useState(getDropDownOptions);
  const [selectedOption, setSelectedOption] = useState(5);
  const isSmallScreen = useMediaQuery({ query: "(max-width: 1220px)" });

  const handleChange = (value) => {
    setSelectedOption(value);
    onTimeFilterChange(value);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setDropDownOptions(getDropDownOptions);
    }, 60 * 1000);
    return () => clearInterval(intervalId);
  }, []);

  const dropDownClass =
    showText && isSmallScreen
      ? "time-range-dropdown-small"
      : "time-range-dropdown-large";
  return (
    <div className="realtime-range-container">
      <div>
        <Select
          value={selectedOption}
          className={dropDownClass}
          onChange={handleChange}
        >
          {dropDownOptions.map((option, index) => {
            return (
              <Option key={index} value={option?.key}>
                <Row gutter={[8, 8]} wrap={false} justify={"space-between"}>
                  <Col>{option?.text}</Col>
                  {showText && !isSmallScreen ? (
                    <Col className="time-range-text">{option?.range}</Col>
                  ) : null}
                </Row>
              </Option>
            );
          })}
        </Select>
      </div>
    </div>
  );
};

export default RealTimeRange;
